import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect } from "react";
import { isCustomize, ready } from "../utils";
import { preDecisionGatewayIsHiddenDueLegal, preDecisionGatewayIsPreventPreDecision, preDecisionGatewayIsDoNotTrack, preDecisionGatewayUserConsent, preDecisionGatewayIsCrawler, preDecisionGatewayDynamicRequest, applyCookies, getDefaultDecision } from "../others";
import { BANNER_PRE_DECISION_SHOW_EVENT } from "../types";

/**
 * Do some decision gateways like DNT, Bot / Crawler and Decision and depending
 * on that, show the Banner initially.
 */
function useBannerPreDecisionGateway(banner, setContextValue, toggleOverlay) {
  // Only run this predecision mechanism once and when not in customize
  !isCustomize() && useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var onSave, gateways, show, _i, _gateways, gateway, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onSave = banner.onSave;
              gateways = [preDecisionGatewayDynamicRequest, preDecisionGatewayIsHiddenDueLegal, preDecisionGatewayIsPreventPreDecision, preDecisionGatewayIsCrawler, preDecisionGatewayIsDoNotTrack, preDecisionGatewayUserConsent];
              show = true;
              _i = 0, _gateways = gateways;

            case 4:
              if (!(_i < _gateways.length)) {
                _context.next = 16;
                break;
              }

              gateway = _gateways[_i];
              _context.next = 8;
              return gateway(banner);

            case 8:
              result = _context.sent;

              if (!(result !== false)) {
                _context.next = 13;
                break;
              }

              show = false;

              if (result === "all") {
                applyCookies("all");
              } else if (result === "essentials") {
                applyCookies("essentials");
              } else if (result === "dnt") {
                // Accept only essentials (save because they are always preselected when no decision given and we need to hold this decision in API)
                onSave(gateway === preDecisionGatewayIsDoNotTrack, "none");
              } else if (result === "consent") {
                // Apply cookies for the current user decision
                applyCookies("consent");
              }

              return _context.abrupt("break", 16);

            case 13:
              _i++;
              _context.next = 4;
              break;

            case 16:
              if (!show) {
                _context.next = 21;
                break;
              }

              setContextValue(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  // Always revert back to "Essentials" only consent when cookie needs to be consented
                  consent: {
                    groups: getDefaultDecision()
                  }
                }, toggleOverlay(state, true));
              }); // Wait all events are initialized

              _context.next = 20;
              return ready();

            case 20:
              // All content blockers should be made visible
              document.dispatchEvent(new CustomEvent(BANNER_PRE_DECISION_SHOW_EVENT, {
                detail: {}
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
}

export { useBannerPreDecisionGateway };